<mat-dialog-container>
  <h2 mat-dialog-title>Confirmar Eliminación</h2>
  <mat-dialog-content>
    <p>¿Está seguro de que desea eliminar este egreso?</p>
  </mat-dialog-content>
  <mat-dialog-actions>
    <!-- <button mat-button (click)="onNoClick()">Cancelar</button>
    <button mat-button color="warn" (click)="confirmDelete()">Eliminar</button> -->
  </mat-dialog-actions>
</mat-dialog-container>
